import EntitlementsCollection from '@/app/models/Entitlements.collection'

export default {
  login: (state) => state.login ? state.login : null,
  companyId: (state) => state.companyId ? parseInt(state.companyId) : null,
  originalCompanyId: (state) => state.originalCompanyId ? state.originalCompanyId : null,
  role: (state) => state.role ? state.role : null,
  entitlements: (state) => new EntitlementsCollection(state.entitlements, state.authenticated),
  token: (state) => state.token,
  mckidToken: (state) => state.mckidToken
}
